import { Box } from "@mui/material";
import type { DetectedEffect, ExtractedColor, Region } from "../../types";
import { UploadMatchAccordion } from "./UploadMatchAccordion";

interface SearchCriteriaPanelProps {
  hasReferenceImage: boolean;
  imageSrc: string;
  palette: ExtractedColor[];
  selectedColorIndex: number;
  onColorSelect: (index: number) => void;
  detectedEffects?: DetectedEffect[];
  onChangeClick: () => void;
  activeRegion?: Region;
  regions?: Region[];
  onRegionClick?: (regionId: string) => void;
}

export const SearchCriteriaPanel = ({
  hasReferenceImage,
  imageSrc,
  palette,
  selectedColorIndex,
  onColorSelect,
  detectedEffects,
  onChangeClick,
  activeRegion,
  regions,
  onRegionClick,
}: SearchCriteriaPanelProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <UploadMatchAccordion
        hasReferenceImage={hasReferenceImage}
        imageSrc={imageSrc}
        palette={palette}
        selectedColorIndex={selectedColorIndex}
        onColorSelect={onColorSelect}
        detectedEffects={detectedEffects}
        onChangeClick={onChangeClick}
        activeRegion={activeRegion}
        regions={regions}
        onRegionClick={onRegionClick}
      />
    </Box>
  );
};
